import React from 'react'
import {BadgeActive} from '../ui'
import { useTranslation } from 'react-i18next';

const SalesReportsListItem = ({item,index}) => {
    const formattedDate = item?.created_at ? item.created_at.substring(0,10) : '-';
    const [t,i18n ] = useTranslation('global')

    return (
        <div
        className="grid grid-cols-12 gap-3 border-t px-4 py-2 cursor-pointer items-center hover:bg-[#251658]/5 hover:font-bold"
      >
        <div className="text-center col-span-1 text-[#251658] text-xs">
        {index + 1}
        </div>
        <div className="col-span-3 text-[#251658] text-xs">
          {item?.product_name?.trim() || '-'}
        </div>
        <div className="text-center col-span-1 text-[#251658] text-xs">
          {item?.qty || '0'}
        </div>
        <div className="text-center col-span-2 text-[#251658] text-xs">
          {item?.balance_before || '-'}
        </div>
        <div className="text-center col-span-2 text-[#251658] text-xs">
          {item?.balance_after || '-'}
        </div>
        <div className="text-center col-span-1 text-[#251658] text-xs">
  {item?.type?.trim() === 'PULL'
    ?t("reports.Permission_Disbursement") 
    : item?.type?.trim() === 'PASH'
      ? t("reports.Permission_Receipt")
      : (item?.type?.trim() || '-')}
</div>

 


        <div className="text-center col-span-2 text-[#251658] text-xs">
          {formattedDate}
        </div>
      </div>
    )
}

export default SalesReportsListItem